<template>
  <div class="wishlist_menu" @mousemove="mouseMove()" @mouseup="mouseUp()" @click="globaFunction()">

    <ModalComponent :isOpen="zoomElement != null" @modal-close="zoomElement = null, replaceImageData = null, newImageFileName = null" 
      name="image-zoom">
      <template #header>{{ zoomElement.product_ID }}</template>
      <template #content>
        <div class="image-zoom-image">
          <img id="zoomProductImage" class='productImage' :src="'https://wishlist.turtleking.com/images/products/'+encodeURIComponent(zoomElement.product_ID)+'.jpg?'+Date.now()"/>
          <div class="upload">
            <div class="uploadBtn"><button>Replace image</button><input type="file" accept=".jpg" @change="uploadNewImage"></div>
          </div>
          <div v-if="newImageFileName != null" class="newFileName">Old image has been renamed to: <a :href="'https://wishlist.turtleking.com/images/products/'+encodeURIComponent(newImageFileName)" target="_blank">{{ newImageFileName }}</a>.</div>
        </div>
      </template>
      <!-- <template #footer>Custom content</template> -->
    </ModalComponent>
    <!-- <h1>Turtle King Wishlist</h1> -->
    <div class="content" :style="{height: contentHeight+ 'px'}">
      <div class="globalMessage" v-if="globalMessage != ''"><span>{{globalMessage}}</span></div>
      <div class="topPane" >
        <a href="https://vendor.turtleking.com"><i class="fa-solid fa-chevron-left"> </i> Back to Vendor portal</a>
        
        <!-- <vue3-slider v-model="leftPaneWidthPercent"  :min="leftPaneWidthPercenMin" :max="leftPaneWidthPercenMax" color="#FB278D" track-color="#FEFEFE" /> -->
      </div>



      <div id="leftPane" class="leftPane" :style="{width:leftPaneWidth}">
        <div class="searchField">
          <input type="text" @keyup="searchProductDebounced" v-model="searchTerm" placeholder="Search keywords"><img v-if="searchingForStylesFlag" src="../assets/Spin@1x-1.0s-200px-200px.gif"/>
          
        </div>
        <div class="filters" :class="{open: openTab}">
          <div class="filterContainer" v-if="showFilters">
            <div class="filterGroup groups">
              <h3>Vendors</h3>
              <div @click="vendor.selected = !vendor.selected; showFilteredProductResults()"  v-for="(vendor, index) in vendorsWithProductCount" class="filter" :key="vendor.Vend_Num">
                <div v-if="vendor.productCount > 0">
                  <input type="checkbox" v-model="vendor.selected" :value="index">
                  <span>{{ vendor.Vend_Num }} ({{ vendor.productCount }})</span>
                </div>
              </div>
              <button @click="vendors.map(v=>v.selected=false); showFilteredProductResults()">Clear Filter</button>
            </div><div class="filterGroup categories">
              <h3>Category</h3>
              <div @click="category.selected = !category.selected; showFilteredProductResults()" v-for="(category, index) in categoriesWithProductCount" class="filter" :key="category.category_ID">
                <input type="checkbox" v-model="category.selected" :value="index">
                <span>{{ category.name }} ({{ category.productCount }})</span>
              </div>
              <button @click="categories.map(v=>v.selected=false); showFilteredProductResults()">Clear Filter</button>
            </div>
            <!-- <div><button>Apply filters</button></div> -->
          </div>
          <div class="openClosetTab" @click="openTab=!openTab"> Filters <i v-if="openTab" class="fa-solid fa-chevron-up"></i><i v-else class="fa-solid fa-chevron-down"></i> </div>
        </div>
        
        <div class="results" >
          <div class="controlPane" >
              <span v-if="productSearchResults.length > 0" class='recordsFound'>{{productSearchResultsNumItemsCount}} records found</span>
              <span class='productSearchResultsNumItems'>
                Results: 
                <select class='productSearchResultsNumItems' @change="searchProductDebounced()" v-model="productSearchResultsNumItems">
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="250">250</option>
                  <!-- <option value="500">500</option> -->
                  <!-- <option value="all">All</option> -->
                </select>
              </span>
          </div>
          <table v-if="productSearchResults.length != 0 ">
            <thead>
              <tr>
                <th></th>
                <th>Product ID</th>
                <th>Description1</th>
                <th>Description 2</th>
                <th>Description 3</th>
                <th></th>
              </tr>
            </thead>
            
            <draggable class="dragArea " v-model="productSearchResults"  :group="{ name: 'products', pull: 'clone', put: false }" tag="tbody" @start="drag=true" @end="drag=false" item-key="product_ID">
              <template #item="{element}">
                <tr v-if="element.show">
                  <td>
                    <i class="fa-solid fa-magnifying-glass-plus" @click="zoomElement = element"></i>
                    <img :class="element.product_ID" class='productImage' :src="'https://wishlist.turtleking.com/images/products/'+encodeURIComponent(element.product_ID)+'.jpg?'+Date.now()" @click="zoomElement = element"/>
                    <i @click="addToWishlist(null, element)" v-if="selectedWishListID != -1" class="fa-solid fa-right-to-bracket"></i>
                    
                  </td>
                  <td @click="selectedProduct = element">{{element.product_ID}}
                    <!-- <br>{{ element.Vend_Num }} -->
                  </td>
                  <td @click="selectedProduct = element">{{element.description1}}</td>
                  <td @click="selectedProduct = element">{{element.description2}}</td>
                  <td @click="selectedProduct = element">{{element.description3}}</td>
                  <td><i @click="addToWishlist(null, element)" v-if="selectedWishListID != -1" class="fa-solid fa-right-to-bracket"></i></td>
                </tr>
              </template>
            </draggable>
          </table>


          <div class="nosearchresult" v-else>No search result</div>
        </div>
      </div>
      <div id="middlePane" class="middlePane" :style="{width:middlePaneWidth}"  @mousedown="mouseDown(index)"></div>
         
         
         
         
         
         
         
         
         
         
         
         
         
         
         
         
         
         
         
         
         
         
         
      <div id="rightPane" class="rightPane" :style="{width:rightPaneWidth}">
        <div class="controlPane">
          <button v-if="selectedWishListID == -1" class="newishlistBtn" @click="createNewWishList">New Wish List</button>
          <button v-if="wishlists.filter(f=>f.selected).length > 0" @click="removeSelectedWishLists">Remove Selected Wish Lists</button>
        </div>

        <div class="wishlistGroups" :class="{hide:!wishlistGroupOpen}">
          <span class="label">FOLDERS </span>
          <span class="newFolder"><input type="text" placeholder="NEW FOLDER NAME" v-model="newWishlistGroupName"><button @click="addWishlistGroup">Add Folder</button></span>
          <div class="openCloseTab" @click="wishlistGroupOpen=!wishlistGroupOpen">
            <span v-if="wishlistGroupOpen"><i class="fa-solid fa-chevron-right"></i></span>
            <span v-else><i class="fa-solid fa-chevron-left"></i></span>
          </div>
          <ul>
            <!-- <li @click="selectWishlistGroup(null)" :class="{selected: group.selected}">HOME </li> -->
            <li v-for="(group, index) in wishlistGroups" v-bind:key="group.id" :class="{selected: group.selected, indented: index != 0}">
              <span 
                  @click="selectWishlistGroup(group)"
                  @dragover.prevent 
                  @drop="handleDropWishlistGroup($event, index)" 
                  @dragenter.prevent
                  class="drop-zone">{{ group.name }} ({{ group.numItems }}) </span><i @click="deleteWishlistGroup(index)" v-if="index != 0" class="fa-solid fa-trash"></i>
            </li>
          </ul>
        </div>
        <div v-if="selectedWishListID == -1" class="wishlists">
          <table class='wishlistsTbl' v-if="wishlists != null && wishlists.length != 0">
            <thead>
              <tr>
                <th><input type="checkbox" v-model="selectAllWishlists" @change="checkUncheckAllWishlists()" value="true"></th>
                <th></th>
                <th @click="changeWishlistSortOrder('name')">Name <span v-if="wishlistSortBy == 'name' && wishlistSortOrder == 'asc'" class="triangle-up"></span><span v-else-if="wishlistSortBy == 'name' && wishlistSortOrder == 'desc'" class="triangle-down"></span></th>
                <th>Footnote</th>
                <th @click="changeWishlistSortOrder('customerID')">Customer<span v-if="wishlistSortBy == 'customerID' && wishlistSortOrder == 'asc'" class="triangle-up"></span><span v-else-if="wishlistSortBy == 'customerID' && wishlistSortOrder == 'desc'" class="triangle-down"></span></th>
                <th @click="changeWishlistSortOrder('category')">Category<span v-if="wishlistSortBy == 'category' && wishlistSortOrder == 'asc'" class="triangle-up"></span><span v-else-if="wishlistSortBy == 'category' && wishlistSortOrder == 'desc'" class="triangle-down"></span></th>
                <th @click="changeWishlistSortOrder('lastUpdated')">Last Updated <span v-if="wishlistSortBy == 'lastUpdated' && wishlistSortOrder == 'asc'" class="triangle-up"></span><span v-else-if="wishlistSortBy == 'lastUpdated' && wishlistSortOrder == 'desc'" class="triangle-down"></span></th>
                <th>Number Of Items</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr 
                draggable="true" 
                v-for="(element) in wishlistsFilteredByGroupID" 
                :key="element.id"
                @dragstart="handleStartDragWishlistGroup($event, element)" 
                :class="{selected: element.selected}"
              >
              <!-- <draggable 
                group="wishlists" 
                class="dragArea" 
                v-model="wishlists"  
                tag="tbody"
                @start="drag=true" 
                @end="drag=false" 
                item-key="id" 
                @change="wishlistGroupChange"
                >
              <template #item="{element, index}"> -->
                <!-- <tr> -->
                  <td><input type="checkbox" v-model="element.selected" @click="checkUncheckWishlist(element, $event)"/></td>
                  <td style="text-align:center;"><button @click="openWishList(element.id)">Open</button><button class="saveBtn" @click="saveWishlistName(element)" v-if="element.modified">Save</button></td>
                  <td>
                    <input type='text' v-model="element.name" size="55" @keyup="wishlistNameChange(element)"/>
                  </td>
                  <td><textarea v-model="element.footnote" @keyup="wishlistNameChange(element)"></textarea></td>
                  <td>
                    <select v-model="element.customerID" @change="wishlistNameChange(element)">
                      <option v-for="customer in customers" :value="customer.customerID" :key="customer.customerID">{{customer.customerID}}</option>
                    </select>
                  </td>
                  <td><input type="text" v-model="element.category" @keyup="wishlistNameChange(element)"></td>
                  <td>{{element.lastUpdated}}</td>
                  <td>{{element.itemCount}}</td>
                  <td>
                    <button @click="duplicateWishlist(element)">Duplicate</button>
                    <button class="saveBtn" @click="saveWishlistName(element)" v-if="element.modified">Save</button>
                  </td>
                </tr>
              <!-- </template>
            </draggable> -->
              </tbody>
          </table>
        </div>
        <div v-else class="wishlistItems">
          <div class="controlPane">
          
            <div class="downloadExcel" style="text-align:left">
              <!-- <span>Customers: </span> -->
              <select name="" id="" v-model="selectedCustomerID" @change="fillInCustomerPriceColumn()">
                <option v-for="customer in customers" :value="customer.customerID" :key="customer">{{ customer.customerID }}</option>
              </select>
              <button @click="generateExcel" class="downloadBtn">Download Excel</button>
            </div>

            <span class="backBtnArea" @click="selectedWishListID = -1; selectedCustomerID= ''">
                <i class="fas fa-chevron-left"></i> BACK
            </span>
            <div class="customers">
            </div>
            <span class="wishlistNameLabel">{{ selectedWishListName}} (Items: {{ selectedWishListItems.length }})</span>
            <div class="modifiedWishListCtl">
              <div v-show="modifiedWishList">
                <span class="astrisk">*</span> 
                <button class="unsaved" @click="saveCurrentWishlist">Click to Save List</button>
              </div>
              <!-- <div v-show="!modifiedWishList">
                  <span>SAVED</span>
              </div> -->
          </div>
          <div class="customizeColumns">
            <span @click="showColumnCustomizeMenu = !showColumnCustomizeMenu">Customize Columns</span>
            <div v-if="showColumnCustomizeMenu">
              <ul v-if="userPreferences.wishlistColumns != undefined">
                <li @click="userPreferences.wishlistColumns.productID = !userPreferences.wishlistColumns.productID; saveUserPreferences()"><input type="checkbox" v-model="userPreferences.wishlistColumns.productID">Product ID</li>
                <li @click="userPreferences.wishlistColumns.Vend_Num = !userPreferences.wishlistColumns.Vend_Num; saveUserPreferences()"><input type="checkbox" v-model="userPreferences.wishlistColumns.Vend_Num">Vend #</li>
                <li @click="userPreferences.wishlistColumns.category_ID = !userPreferences.wishlistColumns.category_ID; saveUserPreferences()"><input type="checkbox" v-model="userPreferences.wishlistColumns.category_ID">Cat #</li>
                <li @click="userPreferences.wishlistColumns.group_ID = !userPreferences.wishlistColumns.group_ID; saveUserPreferences()"><input type="checkbox" v-model="userPreferences.wishlistColumns.group_ID">Color</li>
                <li @click="userPreferences.wishlistColumns.description = !userPreferences.wishlistColumns.description; saveUserPreferences()"><input type="checkbox" v-model="userPreferences.wishlistColumns.description">Description</li>
                <li @click="userPreferences.wishlistColumns.unit_depth = !userPreferences.wishlistColumns.unit_depth; saveUserPreferences()"><input type="checkbox" v-model="userPreferences.wishlistColumns.unit_depth">Size L"</li>
                <li @click="userPreferences.wishlistColumns.unit_width = !userPreferences.wishlistColumns.unit_width; saveUserPreferences()"><input type="checkbox" v-model="userPreferences.wishlistColumns.unit_width">Size W"</li>
                <li @click="userPreferences.wishlistColumns.unit_height = !userPreferences.wishlistColumns.unit_height; saveUserPreferences()"><input type="checkbox" v-model="userPreferences.wishlistColumns.unit_height">Size H"</li>
                <li @click="userPreferences.wishlistColumns.Size = !userPreferences.wishlistColumns.Size; saveUserPreferences()"><input type="checkbox" v-model="userPreferences.wishlistColumns.Size">Size</li>
                <li @click="userPreferences.wishlistColumns.inner_size = !userPreferences.wishlistColumns.inner_size; saveUserPreferences()"><input type="checkbox" v-model="userPreferences.wishlistColumns.inner_size">Inner Pk</li>
                <li @click="userPreferences.wishlistColumns.case_pack = !userPreferences.wishlistColumns.case_pack; saveUserPreferences()"><input type="checkbox" v-model="userPreferences.wishlistColumns.case_pack">Case Pk</li>
                <li @click="userPreferences.wishlistColumns.case_Vol = !userPreferences.wishlistColumns.case_Vol; saveUserPreferences()"><input type="checkbox" v-model="userPreferences.wishlistColumns.case_Vol">Case Vol(CBM)</li>
                <li @click="userPreferences.wishlistColumns.unit = !userPreferences.wishlistColumns.unit; saveUserPreferences()"><input type="checkbox" v-model="userPreferences.wishlistColumns.unit">Unit (CBM)</li>
                <li @click="userPreferences.wishlistColumns.Base_Cost = !userPreferences.wishlistColumns.Base_Cost; saveUserPreferences()"><input type="checkbox" v-model="userPreferences.wishlistColumns.Base_Cost">Base Cost</li>

                <li @click="userPreferences.wishlistColumns.poQty = !userPreferences.wishlistColumns.poQty; saveUserPreferences()"><input type="checkbox" v-model="userPreferences.wishlistColumns.poQty">PO Qty</li>
                <li @click="userPreferences.wishlistColumns.ctns = !userPreferences.wishlistColumns.ctns; saveUserPreferences()"><input type="checkbox" v-model="userPreferences.wishlistColumns.ctns">CTNs</li>
                <li @click="userPreferences.wishlistColumns.cbm = !userPreferences.wishlistColumns.cbm; saveUserPreferences()"><input type="checkbox" v-model="userPreferences.wishlistColumns.cbm">CBM</li>
                <li @click="userPreferences.wishlistColumns.amt = !userPreferences.wishlistColumns.amt; saveUserPreferences()"><input type="checkbox" v-model="userPreferences.wishlistColumns.amt">Amt</li>
                <li @click="userPreferences.wishlistColumns.inStockQty = !userPreferences.wishlistColumns.inStockQty; saveUserPreferences()"><input type="checkbox" v-model="userPreferences.wishlistColumns.inStockQty">In Stock Qty</li>
                <li @click="userPreferences.wishlistColumns.openSoQty = !userPreferences.wishlistColumns.openSoQty; saveUserPreferences()"><input type="checkbox" v-model="userPreferences.wishlistColumns.openSoQty">Open SO Qty</li>
                <li @click="userPreferences.wishlistColumns.availableQty = !userPreferences.wishlistColumns.availableQty; saveUserPreferences()"><input type="checkbox" v-model="userPreferences.wishlistColumns.availableQty">Avail Qty(Instock-S/O)</li>
                <li @click="userPreferences.wishlistColumns.woQty = !userPreferences.wishlistColumns.woQty; saveUserPreferences()"><input type="checkbox" v-model="userPreferences.wishlistColumns.woQty">OW Qty</li>
                <li @click="userPreferences.wishlistColumns.availableQty1 = !userPreferences.wishlistColumns.availableQty1; saveUserPreferences()"><input type="checkbox" v-model="userPreferences.wishlistColumns.availableQty1">Avail Qty (Immediate + OW)</li>
                <li @click="userPreferences.wishlistColumns.poQty1 = !userPreferences.wishlistColumns.poQty1; saveUserPreferences()"><input type="checkbox" v-model="userPreferences.wishlistColumns.poQty1">PO Qty</li>
                <li @click="userPreferences.wishlistColumns.More_Notes_13 = !userPreferences.wishlistColumns.More_Notes_13; saveUserPreferences()"><input type="checkbox" v-model="userPreferences.wishlistColumns.More_Notes_13">Retailer</li>
                <li @click="userPreferences.wishlistColumns.More_Notes_14 = !userPreferences.wishlistColumns.More_Notes_14; saveUserPreferences()"><input type="checkbox" v-model="userPreferences.wishlistColumns.More_Notes_14">MSRP</li>
                <li @click="userPreferences.wishlistColumns.More_Notes_16 = !userPreferences.wishlistColumns.More_Notes_16; saveUserPreferences()"><input type="checkbox" v-model="userPreferences.wishlistColumns.More_Notes_16">Inner Box Type</li>
                <li @click="userPreferences.wishlistColumns.More_Notes_17 = !userPreferences.wishlistColumns.More_Notes_17; saveUserPreferences()"><input type="checkbox" v-model="userPreferences.wishlistColumns.More_Notes_17">Hang Tag / Location</li>
                <li @click="userPreferences.wishlistColumns.lastSoldPrice = !userPreferences.wishlistColumns.lastSoldPrice; saveUserPreferences()"><input type="checkbox" v-model="userPreferences.wishlistColumns.lastSoldPrice">Customer Price</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="wishlistItemsTblDiv">
          <table class="wishlistItemsTbl" v-if="selectedWishListItems != null">
          <thead>
            <tr>
              <th></th>
              <th></th>
              <th v-if="userPreferences.wishlistColumns.productID">Product ID</th>
              <th v-if="userPreferences.wishlistColumns.Vend_Num">Vend#</th>
              <th v-if="userPreferences.wishlistColumns.category_ID">Cat #</th>
              <th v-if="userPreferences.wishlistColumns.group_ID">Color</th>
              <th v-if="userPreferences.wishlistColumns.description">Description</th>
              <th v-if="userPreferences.wishlistColumns.unit_depth">Size L"</th>
              <th v-if="userPreferences.wishlistColumns.unit_width">Size W"</th>
              <th v-if="userPreferences.wishlistColumns.unit_height">Size H"</th>
              <th v-if="userPreferences.wishlistColumns.Size" >Size</th>
              <th v-if="userPreferences.wishlistColumns.inner_size">Inner Pk</th>
              <th v-if="userPreferences.wishlistColumns.case_pack">Case Pk</th>
              <th v-if="userPreferences.wishlistColumns.case_Vol">Case Vol(CBM)</th>
              <th v-if="userPreferences.wishlistColumns.unit">Unit (CBM)</th>
              <th v-if="userPreferences.wishlistColumns.Base_Cost">Base Cost</th>

              <th v-if="userPreferences.wishlistColumns.poQty">PO Qty</th>
              <th v-if="userPreferences.wishlistColumns.ctns">CTNs</th>
              <th v-if="userPreferences.wishlistColumns.cbm">CBM</th>
              <th v-if="userPreferences.wishlistColumns.amt">Amt</th>

              <th v-if="userPreferences.wishlistColumns.inStockQty">In Stock Qty</th>
              <th v-if="userPreferences.wishlistColumns.openSoQty">Open SO Qty</th>
              <th v-if="userPreferences.wishlistColumns.availableQty">Avail Qty(Instock-S/O)</th>
              <th v-if="userPreferences.wishlistColumns.woQty">OW Qty</th>
              <th v-if="userPreferences.wishlistColumns.availableQty1">Avail Qty (Immediate + OW)</th>
              <th v-if="userPreferences.wishlistColumns.poQty1">PO Qty</th>
              <th v-if="userPreferences.wishlistColumns.More_Notes_13">Retailer</th>
              <th v-if="userPreferences.wishlistColumns.More_Notes_14">MSRP</th>
              <th v-if="userPreferences.wishlistColumns.More_Notes_16">Inner Box Type</th>
              <th v-if="userPreferences.wishlistColumns.More_Notes_17">Hang Tag / Location</th>
              <th v-if="userPreferences.wishlistColumns.lastSoldPrice">Customer Price</th>
            </tr>
          </thead>
            <draggable 
              group="products" 
              class="dragArea" 
              v-model="selectedWishListItems"  
              tag="tbody"
              @start="drag=true" 
              @end="drag=false" 
              item-key="id" 
              @add="addToWishlist" 
              @change="wishlistChange"
              >
              <template #item="{element}">
                <tr>  
                  <td style="width:10%;text-align:center;">
                    <i @click="duplicateWishlistItem(element)" alt="Copy" class="fa-solid fa-copy"></i>
                    <i @click="removeFromWishList(element)" alt="Remove" class="fa-solid fa-trash-can"></i>
                  </td>
                  <td><i class="fa-solid fa-magnifying-glass-plus" @click="zoomElement = element"></i><img :class="element.product_ID" class='productImage' :src="'https://wishlist.turtleking.com/images/products/'+encodeURIComponent(element.product_ID)+'.jpg?'+Date.now()" @click="zoomElement = element"/></td>
                  <td v-if="userPreferences.wishlistColumns.productID" style="width:10%">{{element.productID}}</td>
                  <td v-if="userPreferences.wishlistColumns.Vend_Num" style="width:10%;">{{element.Vend_Num}}</td>
                  <td v-if="userPreferences.wishlistColumns.category_ID" style="width:10%;">{{element.category_ID}}</td>
                  <td v-if="userPreferences.wishlistColumns.group_ID" style="width:10%;">{{element.group_ID}}</td>
                  <td v-if="userPreferences.wishlistColumns.description" style="width:50%;">{{element.description1}}</td>
                  <td v-if="userPreferences.wishlistColumns.unit_depth" style="width:10%;">{{element.unit_depth}}</td>
                  <td v-if="userPreferences.wishlistColumns.unit_width" style="width:10%;">{{element.unit_width}}</td>
                  <td v-if="userPreferences.wishlistColumns.unit_height" style="width:10%;">{{element.unit_height}}</td>
                  <td v-if="userPreferences.wishlistColumns.Size" style="width:10%;">{{element.Size}}</td>
                  <td v-if="userPreferences.wishlistColumns.inner_size" style="width:10%;">{{element.inner_pack}}</td>
                  <td v-if="userPreferences.wishlistColumns.case_pack" style="width:10%;">{{element.case_pack}}</td>
                  <td v-if="userPreferences.wishlistColumns.case_Vol" style="width:10%">{{parseFloat((parseFloat(element.Case_Vol) / 35.314).toFixed(4))}}</td>
                  <td v-if="userPreferences.wishlistColumns.unit" style="width:10%">{{parseFloat((parseFloat(element.Case_Vol) / 35.314 / element.case_pack).toFixed(4))}}</td>
                  <td v-if="userPreferences.wishlistColumns.Base_Cost" style="width:10%;">{{element.Base_Cost.toFixed(2)}}</td>
                  <td v-if="userPreferences.wishlistColumns.poQty" style="width:10%;"> </td>
                  <td v-if="userPreferences.wishlistColumns.ctns" style="width:10%;"> </td>
                  <td v-if="userPreferences.wishlistColumns.cbm" style="width:10%;"> </td>
                  <td v-if="userPreferences.wishlistColumns.amt" style="width:10%;"> </td>
                  <td v-if="userPreferences.wishlistColumns.inStockQty" style="width:10%;">{{element.inStock}}</td>
                  <td v-if="userPreferences.wishlistColumns.openSoQty" style="width:10%;">{{element.openSO}}</td>
                  <td v-if="userPreferences.wishlistColumns.availableQty" style="width:10%;">{{element.inStock - element.openSO}}</td>
                  <td v-if="userPreferences.wishlistColumns.woQty" style="width:10%;">{{element.woQty}}</td>
                  <td v-if="userPreferences.wishlistColumns.availableQty1" style="width:10%;">{{element.inStock + element.woQty}}</td>
                  <td v-if="userPreferences.wishlistColumns.poQty1" style="width:10%;">{{element.poQty}}</td>
                  <td v-if="userPreferences.wishlistColumns.More_Notes_13" style="width:10%;">{{element.More_Notes_13}}</td>
                  <td v-if="userPreferences.wishlistColumns.More_Notes_14" style="width:10%;">{{element.More_Notes_14}}</td>
                  <td v-if="userPreferences.wishlistColumns.More_Notes_16" style="width:10%;">{{element.More_Notes_16}}</td>
                  <td v-if="userPreferences.wishlistColumns.More_Notes_17" style="width:10%;">{{element.More_Notes_17}}</td>
                  <td  v-if="userPreferences.wishlistColumns.lastSoldPrice" style="width:10%;">${{ element.lastSoldPrice }}</td>
                </tr>
              </template>
            </draggable>
          </table>

          <div class="bulk_addToWishlist_Area">
            <span>Enter one sku per line</span>
            <textarea v-model="bulk_addToWishlist_Area" name="" id=""></textarea>
            <button @click="bulk_addToWishlist">Upload</button>
          </div>
        </div>

        </div>
      </div> <!-- end rightPane-->
    
    </div> <!-- end content -->
  </div>
</template>
  



















<script>
  import draggable from 'vuedraggable'
  import { useCookies } from "vue3-cookies";
// import { atanh } from 'core-js/core/number';
import ModalComponent from "../components/ModalComponent.vue";
 const { cookies } = useCookies();
  export default {
    name: 'WishList',
    props: {
      msg: String
    },
    components:{
      ModalComponent,
      draggable,
    },
    data() {
      return {
        zoomElement: null,
        replaceImageData: null,
        newImageFileName: null,
        user: null,
        userPreferences: null,
        showColumnCustomizeMenu: false,
        globalMessage: '',
        contentHeight: "1000",
        // search products
        timerId: null,
        searchTerm: '',
        productSearchResults: [],
        filteredProductSearchResults: [],
        productSearchResultsNumItems: 25,
        productSearchResultsNumItemsCount: -1,
        selectedProduct: null,
        searchingForStylesFlag: false,
        showFilters: true,
        categories: [],
        groups: [],
        vendors: [],
        openTab:false,


        //wishlist
        wishlists:[],
        customers:[],
        selectedCustomerID: '',
        targetWishListIndex: -1, // targe wishlist index to insert product to. -1 if none is selected
        selectedWishListID: -1,
        selectedWishListItems: [], // selected wishlist items
        modifiedWishListFlag: false,
        selectAllWishlists: false,
        lastCheckedWishlistIndex: -1,

        wishlistSortBy: 'name',
        wishlistSortOrder: 'desc',
        bulk_addToWishlist_Area: '',
        wishlistGroups: [],
        wishlistGroupOpen: true,
        selectedWishlistGroupID: null,
        newWishlistGroupName: '',


        // draggable pane width
        draggingBorder: false,
        draggableBorderStartingPoint: 0,
        leftPaneWidth: "calc(30% - 3px)",
        rightPaneWidth: "calc(70% - 3px)",
        middlePaneWidth: 0,
        leftWidth: 0,
        rightWidth: 0,
        windowWidth: document.documentElement.clientWidth,
        // leftPaneWidthPercent:50,
        // leftPaneWidthPercenMin:1,
        // leftPaneWidthPercenMax:100,



        // maxValue:10
      }
      
    },
    methods:{
      uploadNewImage(evt){
        console.log('upload new image')
        let that = this
        var tgt = evt.target || window.event.srcElement,
            files = tgt.files;

        // FileReader support
        if (FileReader && files && files.length) {
            var fr = new FileReader();
            fr.onload = function () {
              document.getElementById('zoomProductImage').src = fr.result;
              let allImageElements = document.getElementsByClassName(that.zoomElement.product_ID)
              setTimeout(function(){
                for (let i = 0; i < allImageElements.length; i++) {
                  allImageElements[i].src = 'https://wishlist.turtleking.com/images/products/'+encodeURIComponent(that.zoomElement.product_ID)+'.jpg?'+Date.now()
                }

              }, 1000)
              that.replaceImageData = fr.result
              that.axios.post(process.env.VUE_APP_API_BASE_URL+'/replaceProductImage',
                {
                    data: fr.result,
                    product_ID: that.zoomElement.product_ID
                }
              ).then((response) => {
                console.log(response.data)
                that.newImageFileName = response.data.newImageFileName

              }).catch(error=>{
                that.displayGlobalMessage('Encountered error (replace product image).')
                console.log(error.message)
              })

            }
            fr.readAsDataURL(files[0]);
            console.log('uploaded')
        }
        // Not supported
        else {
            // fallback -- perhaps submit the input to an iframe and temporarily store
            // them on the server until the user's session ends.
        }
      },  
      globaFunction(){
        // this.productSearchResults.map(p=>p.zoom = false)
      },
      displayGlobalMessage(message, interval=500) {
        let that = this
        this.globalMessage = message
        setTimeout(function(){
          that.globalMessage = ''
        }, interval)
      },  

      getCriteria() {
        this.axios.post(process.env.VUE_APP_API_BASE_URL+'/getCriteria',
            {
                
            }
          ).then((response) => {
            // console.log(response)
            this.groups = response.data.result.groups
            this.groups.map(group=>group.selected=false)
            this.categories = response.data.result.categories
            this.categories.map(category=>category.selected=false)
            this.vendors = response.data.result.vendors
            this.vendors.map(vendor=>vendor.selected=false)
          }).catch(error=>{
            this.displayGlobalMessage('Encountered error (getCriteria).  Trying in 5 seconds.')
            console.log(error.message)
          })
      },


      searchProductDebounced() {
        let that = this
        // if(this.searchTerm.trim() != '') {
          clearInterval(this.timerId)
          this.timerId = setTimeout(function() {
            that.displayGlobalMessage('Fetching Products')
            that.searchingForStylesFlag = true
            that.axios.post(process.env.VUE_APP_API_BASE_URL+'/searchProductsByKeywords',
              {
                keyword: that.searchTerm,
                productSearchResultsNumItems: that.productSearchResultsNumItems,
                // categories: that.categories.filter(category=>category.selected).map(category=>category.category_ID),
                // groups: that.groups.filter(group=>group.selected).map(group=>group.group_ID),
                // vendors: that.vendors.filter(vendor=>vendor.selected).map(vendor=>vendor.Vend_Num),
              }
            ).then((response) => {
              that.productSearchResults = response.data.results
              that.productSearchResultsNumItemsCount = response.data.numCount
              
              that.vendors.map(v=>v.productCount = 0)
              that.categories.map(c=>c.productCount = 0)

              
              that.productSearchResults.map(p=>{
                if(p.Vend_Num == 'VEND#')
                  console.log(p.product_ID)
                let index = that.vendors.findIndex(v=>v.Vend_Num == p.Vend_Num)
                if(index != -1) {
                  that.vendors[index].productCount ++
                }
                index = that.categories.findIndex(c=>c.category_ID == p.category_ID)
                if(index != -1) {
                  that.categories[index].productCount ++
                }
                p.inStock = 0
                p.openSO = 0
                p.woQty = 0
                p.poQty = 0
                p.show = true
                p.lastSoldPrice = 0
              })

              
              that.vendors.map(v=>{
                // v.productCount == 0 ? v.selected = false : ''
                v.selected = false
              })
              that.categories.map(c=>{
                //  c.productCount == 0 ? c.selected = false : ''
                 c.selected = false
              })
              that.searchingForStylesFlag = false
            }).catch(error=>{
              that.displayGlobalMessage('Encountered error (searchProductDebounced).  Trying in 5 seconds.')
              console.log(error.message)
            })
          }, 500) 
      },
      setPaneWidth(windowResize=false) {
        // if calling this function becuase its not window being resized, then its cause by user dragging the middle pane.
        if(!windowResize) {
            const leftDiv = document.getElementById('leftPane');
            const rightDiv = document.getElementById('rightPane');
            if(leftDiv != undefined) {
              this.leftWidth = this.leftWidth == 0 ? leftDiv.offsetWidth - 1 :  this.leftPaneWidth; // Returns the width in pixels
              this.rightWidth = this.rightWidth == 0 ? rightDiv.offsetWidth : this.rightPaneWidth; // Returns the width in pixels
              // // console.log('setPaneWidth ' + width - this.draggableMovementPixel)
              if(this.draggableMovementPixel > 0) {
                this.leftPaneWidth = parseInt(this.leftWidth) + Math.abs(this.draggableMovementPixel) + 'px'
                this.rightPaneWidth = parseInt(this.rightWidth) - Math.abs(this.draggableMovementPixel) + 'px'
              } else {
                this.leftPaneWidth = parseInt(this.leftWidth) - Math.abs(this.draggableMovementPixel) + 'px'
                this.rightPaneWidth = parseInt(this.rightWidth) + Math.abs(this.draggableMovementPixel) + 'px'
              }
            }
          this.$forceUpdate()
        } else {
          // browser width is resized. 
            const leftDiv = document.getElementById('leftPane');
            let diff = document.documentElement.clientWidth - this.windowWidth
            if(leftDiv != undefined) {
              if(diff > 0) {
                this.leftPaneWidth = parseInt(this.leftPaneWidth) + (Math.abs(diff)/2) + 'px'
                this.rightPaneWidth = parseInt(this.rightPaneWidth) + (Math.abs(diff)/2) + 'px'
              } else {
                this.leftPaneWidth = parseInt(this.leftPaneWidth) - (Math.abs(diff)/2) + 'px'
                this.rightPaneWidth = parseInt(this.rightPaneWidth) - (Math.abs(diff)/2) + 'px'
              }
              this.windowWidth = document.documentElement.clientWidth
            
            } 
        }

      },
      mouseUp(){
        this.draggingBorder = false
      },
      mouseDown() {
        this.draggingBorder = true
        this.draggableBorderStartingPoint = event.clientX
      },
      mouseMove() {
        if(this.draggingBorder) {
          // console.log("mouse move "+ event.clientX, this.draggableBorderStartingPoint)
          this.draggableMovementPixel = parseInt(event.clientX) - parseInt(this.draggableBorderStartingPoint)

          // console.log('draggablemovementpixe ' + this.draggableMovementPixel)
          this.draggableBorderStartingPoint = event.clientX
          this.setPaneWidth()
        }
      },




      /////////////////// wishlist
      saveCurrentWishlist() {
        let that = this
        that.globalMessage = "Saving List ..."
        this.axios.post(process.env.VUE_APP_API_BASE_URL+'/saveCurrentWishlist',
            {
              wishlistID: that.selectedWishListID,
              wishlistItems: this.selectedWishListItems
            }
          ).then((response) => {
            // this.results = response.data.results
            if(response.data.success){
              that.selectedWishListItems.map(w=>w.new=false)
              that.modifiedWishListFlag = false
              
              that.wishlists.map(w=>{
                if(w.id == that.selectedWishListID)
                  w.itemCount = that.selectedWishListItems.length
              })

              that.displayGlobalMessage("List Saved", 500)
              that.$forceUpdate()
              // console.log(response.data)
            }
          })
      },
      getAllWishlist() {
        let that = this
        this.axios.post(process.env.VUE_APP_API_BASE_URL+'/getWishlists',
            {
              user: that.user
            }
          ).then(async(response) => {
            // this.wishlists = response.data.combinedWishlists
            this.wishlists = response.data.wishlists
            this.wishlists.map(w=>{
              w.selected = false
              w.name_temp = w.name
              w.footnote_temp = w.footnote
              w.category_temp = w.category
              w.customerID_temp = w.customerID
              w.itemCount = 0
              w.modified = false
            })
            this.customers = response.data.customers
            this.customers.unshift({customerID: ''})
            this.wishlistGroups = response.data.mylist_groups
            this.wishlistGroups.map(g=>{
              g.selected = false
              g.numItems = that.wishlists.filter(w=>w.groupID == g.id).length
            })
            this.wishlistGroups.unshift({
              name: 'home',
              id: null,
              selected: true,
              numItems: that.wishlists.filter(w=>w.groupID == null).length
            })
            
            response = await this.axios.post(process.env.VUE_APP_API_BASE_URL+'/getWishlistItemCounts',{})
          
            for(let i = 0; i < response.data.results.length; i ++) {

              let index = that.wishlists.findIndex(w2=>w2.id == response.data.results[i].id)
              if(index != -1) {
                that.wishlists[index].itemCount = response.data.results[i].itemCount
              }
            }


            // })

                // this.wishlists[i].itemCount = response.data.result.itemCount
              // } catch(e){
              //   console.log(this.wishlists[i])
              //   console.log(e.message)
              // }
            // }
              
          }).catch(error=>{
            this.displayGlobalMessage('Encountered error (getAllWishlist).  Trying in 5 seconds.')
            console.log(error.message)
          })
      },
      createNewWishList(){
        let that = this
        this.axios.post(process.env.VUE_APP_API_BASE_URL+'/createNewWishlist',
        {
          user: this.user,
          wishlistGroupID: this.selectedWishlistGroupID
        } ).then((response) => {
          console.log(response)
          if(response.data.success) {
            let newWishlist = response.data.result
            newWishlist.name_temp = newWishlist.name
            newWishlist.category_temp = newWishlist.category
            newWishlist.customerID_temp = newWishlist.customerID
            newWishlist.footnote_temp = newWishlist.footnote
            newWishlist.modified = false
            this.wishlists.unshift(newWishlist)
            this.wishlistGroups.map(wg=>{
              if(wg.id == that.selectedWishlistGroupID)
                wg.numItems ++
            })
          } else {
            this.displayGlobalMessage(response.data.message)
          }
        })
      },
      duplicateWishlist(wishlistID){
        //TODO: send to server
        this.axios.post(process.env.VUE_APP_API_BASE_URL+'/duplicateWishlist',{wishlistID: wishlistID.id} ).then((response) => {
          console.log(response)
          if(response.data.success) {
            let newWishlist = response.data.result
            newWishlist.name_temp = newWishlist.name
            newWishlist.category_temp = newWishlist.category
            newWishlist.customerID_temp = newWishlist.customerID
            newWishlist.footnote_temp = newWishlist.footnote
            newWishlist.modified = false
            this.wishlists.unshift(newWishlist)
            this.wishlistGroups.map(wg=>{
              if(wg.id == newWishlist.groupID)
                wg.numItems ++
            })
          } else {
            this.displayGlobalMessage(response.data.message)
          }
        })
      },
      async removeSelectedWishLists(){
        if(confirm("This action is permanent. Are you sure?")) {
          let wishlistIDs = [], that = this
          this.wishlists.forEach(f=>{
            if(f.selected)
              wishlistIDs.push(f.id)
          })
          if(wishlistIDs.length > 0) {

            await this.axios.post(process.env.VUE_APP_API_BASE_URL+'/deleteWishlists',{wishlistIDs})
            wishlistIDs.forEach(element => {
              let wishlistIndex = that.wishlists.findIndex(w=>w.id == element)
              if(wishlistIndex != -1)
                that.wishlists.splice(wishlistIndex, 1)
            });
          }


        }
      },
      // removeWishlist(wishlistIndex){
      //   //TODO: send to server
      //   console.log(wishlistIndex)
      //   if(confirm("This action is permanent. Are you sure?"))
      //     this.axios.post(process.env.VUE_APP_API_BASE_URL+'/deleteWishlist',{wishlistID: this.wishlists[wishlistIndex].id} ).then((response) => {
      //       if(response.data.success) {
      //         // console.log(response)
      //         this.wishlists.splice(wishlistIndex, 1)
      //       }
      //     })
      // },
      saveWishlistName(wishlist){
        //TODO: send to server
        this.axios.post(process.env.VUE_APP_API_BASE_URL+'/saveWishlistName',{wishlist} ).then((response) => {
          console.log(response)
          wishlist.name_temp = wishlist.name
          wishlist.category_temp = wishlist.category
          wishlist.customerID_temp = wishlist.customerID
          wishlist.footnote_temp = wishlist.footnote 
          wishlist.modified = false;
          this.displayGlobalMessage("'" + wishlist.name + "' saved", 1000)
        })
      },
      // saveWishlistFootnote(wishlistIndex) {
      //   //TODO: send to server
      //   this.wishlists[wishlistIndex].footnote = this.wishlists[wishlistIndex].footnote_temp
      //   this.wishlists[wishlistIndex].footnoteEdit = false;
      //   this.axios.post(process.env.VUE_APP_API_BASE_URL+'/saveWishlistFootnote',{wishlistID: this.wishlists[wishlistIndex].id, footnote: this.wishlists[wishlistIndex].footnote} ).then((response) => {
      //       // if(response.data.success) {
      //         console.log(response)

      //       // }
      //     })
      // },
      // get all items in a wishlist
      openWishList(wishlistID) {
        this.selectedWishListID = wishlistID

        
        this.modifiedWishListFlag = false
        this.displayGlobalMessage("Loading wishlist items")
        this.axios.post(process.env.VUE_APP_API_BASE_URL+'/getWishlistItemsByID',
          {
            wishlistID: wishlistID
          }
        ).then((response) => {
          // this.results = response.data.results
          console.log(response.data.results)
          this.selectedWishListItems = response.data.results
          this.selectedWishListItems.map(i=>{
            i.lastSoldPrice = 0
            i.inStock = 0
            i.openSO = 0
            i.woQty = 0
            i.poQty = 0
            i.show = true
            
          })
        })
      },
      removeFromWishList(item){
        let index = this.selectedWishListItems.findIndex(i=>{
          return i.product_ID == item.product_ID
        })
        if(index != -1) {
          this.selectedWishListItems.splice(index, 1)
          this.modifiedWishListFlag = true;
          this.$forceUpdate()
        }
      },
      duplicateWishlistItem(item){
        let index = this.selectedWishListItems.findIndex(i=>{
          return i.product_ID == item.product_ID
        })
        if(index != -1) {
          // this.selectedWishListItems.unshift(item)
          this.selectedWishListItems.push(item)
          this.modifiedWishListFlag = true;
          this.$forceUpdate()
        }
      },
      wishlistGroupChange(event){
        // if(event.ctrlKey) {
        //   console.log(wishlist.selected = !wishlist.selected)
        //   console.log('selecting wishlist row')
        // }
        console.log('wishlist group change', event)
      },
      wishlistChange() {
        console.log('wishlist change')
        // if new item added .. then let function "addToWishlist" to handle duplicate
        if(this.selectedWishListItems.findIndex(item=>item.productID == undefined) == -1)
          this.modifiedWishListFlag=true

      },
      wishlistNameChange(wishlist){
        if(
          wishlist.name_temp != wishlist.name ||
          wishlist.footnote_temp != wishlist.footnote ||
          wishlist.category_temp != wishlist.category ||
          wishlist.customerID_temp != wishlist.customerID
        ) {
          wishlist.modified = true
        } else
          wishlist.modified = false

      },
      addToWishlist(event, itemToAdd) {
        console.log('add to wishlist')
        // from dragging products from left pane to right pane
        if(event != undefined && event.oldIndex != undefined && event.newIndex != undefined) {
        
          // if(this.selectedWishListItems.findIndex(item => {
          //   return item.productID == this.productSearchResults[event.oldIndex].product_ID
          // }) != -1) {
          //   console.log('item already in the list')
          //   // this.selectedWishListItems.splice(event.newIndex, 1)
          //   this.displayGlobalMessage("This item is already in the wish list", 700)
          //   this.$forceUpdate()
          //   return false;
          // } 
          console.log('adding to list '+event.newIndex)
          this.selectedWishListItems[event.newIndex].productID = this.productSearchResults[event.oldIndex].product_ID;
          this.selectedWishListItems[event.newIndex].cost = 0;
          this.selectedWishListItems[event.newIndex].wishlistID = this.selectedWishListID,
          this.selectedWishListItems[event.newIndex].availableQty = 0;
          this.selectedWishListItems[event.newIndex].new = true;
          this.selectedWishListItems[event.newIndex].weight = -1;
          this.modifiedWishListFlag = true;
          this.$forceUpdate()
          
        } else { 
          console.log('click to add to wishlist')
          console.log(itemToAdd, itemToAdd.product_ID)

          // if(this.selectedWishListItems.findIndex(item => {
          //   return item.productID == itemToAdd.product_ID
          // }) != -1) {
          //   console.log('item already in the list')
          //   // this.selectedWishListItems.splice(event.newIndex, 1)
          //   this.displayGlobalMessage("This item is already in the wish list", 700)
          //   this.$forceUpdate()
          //   return false;
          // }
          // add to the top of the array
          
          this.selectedWishListItems.unshift({
            productID: itemToAdd.product_ID,
            cost: 0,
            wishlistID: this.selectedWishListID,
            availableQty: 0,
            new: true,
            weight: -1,
            ... itemToAdd

          })
          // this.selectedWishListItems[event.newIndex].productID = this.productSearchResults[event.oldIndex].product_ID;
          // this.selectedWishListItems[event.newIndex].cost = 0;
          // this.selectedWishListItems[event.newIndex].wishlistID = this.selectedWishListID,
          // this.selectedWishListItems[event.newIndex].availableQty = 0;
          // this.selectedWishListItems[event.newIndex].new = true;
          // this.selectedWishListItems[event.newIndex].weight = -1;
          this.modifiedWishListFlag = true;
          this.$forceUpdate()
        }
      },
      bulk_addToWishlist(){
        let that  = this
        if(this.bulk_addToWishlist_Area.trim() != '') {
          let styles = []
          this.bulk_addToWishlist_Area.trim().split('\n').map(item=>item.trim()).forEach(item=>{
            if(item.trim() != '')
              styles.push(item.toUpperCase())
          })
          // console.log(styles)

          this.axios.post(process.env.VUE_APP_API_BASE_URL+'/bulkAddToWishListItems',{styles, wishlistID: this.selectedWishListID } ).then((response) => {
            console.log(response)
            let wishlistIndex = that.wishlists.findIndex(w=>w.id == that.selectedWishListID)
            that.wishlists[wishlistIndex].itemCount = response.data.itemCount
            that.openWishList(that.selectedWishListID)
            
            that.bulk_addToWishlist_Area = response.data.noneExistentItems.join('\n')
          })



        }
      },
      changeWishlistSortOrder(columnName) {
        console.log(columnName)
        let that = this
        this.wishlistSortBy = columnName
        this.wishlistSortOrder = this.wishlistSortOrder == 'asc' ? 'desc' : 'asc'
        this.wishlists.sort((a, b) => that.wishlistSortOrder == 'asc' ? 
          (a[columnName].toUpperCase() > b[columnName].toUpperCase() ? 1 : -1) : (a[columnName].toUpperCase() < b[columnName].toUpperCase() ? 1: -1));
        console.log(this.wishlists[0].id)
        this.$forceUpdate()
      },
      checkUncheckWishlist(wishlistItem, event) {
        console.log(event.shiftKey, event.ctrlKey, wishlistItem.selected)
        
        // if((event.shiftKey || event.ctrlKey) && this.lastCheckedWishlistIndex != -1 && !wishlistItem.selected) {
        //   console.log('multi')
        //   let max, min
        //   if(this.lastCheckedWishlistIndex > index) {
        //     max = this.lastCheckedWishlistIndex
        //     min = index
        //   } else {
        //     min = this.lastCheckedWishlistIndex
        //     max = index
        //   }
        //   for(let i = min; i <= max; i ++) {
        //     this.wishlists[i].selected = true
        //   }
        //   console.log(min, max)
        // }

        // if(!wishlistItem.selected) {
        //   this.lastCheckedWishlistIndex = index   
        // } else {
        //   this.selectAllWishlists = false
        //   this.lastCheckedWishlistIndex = -1
        // }
        
        
        if(wishlistItem.selected)
          this.selectAllWishlists = false


        // console.log(wishlistItem)
        // console.log(event)
      },
      checkUncheckAllWishlists() {
        console.log(this.selectAllWishlists)
        if(this.selectAllWishlists) {
          this.wishlists.map(w=>w.selected=true)
        } else
        this.wishlists.map(w=>w.selected=false)
      },
      generateExcel() {
        ///quotations/mylist_120624/:id([0-9]+)/:customerID
        if(this.selectedCustomerID == '') {
          this.displayGlobalMessage("Select a customer from the drop down menu", 500)
          return false
        } 
        
        this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/quotations/mylist_120624/${this.selectedWishListID}/${this.selectedCustomerID}/${this.user.email}`
        ).then((response) => {
          console.log(response)
          // this.results = response.data.results
          // console.log(response.data.results)
          // this.selectedWishListItems = response.data.results
          const link = document.createElement('a');
          link.href = '/excel_output/'+response.data.filename; // Or a Blob URL
          console.log(link.href)
          link.target = '_blank'
          link.download = response.data.filename;
          link.click();
          URL.revokeObjectURL(link.href);
        })
      },
      // handleDragOverWishlistFolder(event) {
        // console.log("handleDragOverWishlistFolder")
        // console.log(event)
      //  },
      // drop wishlist to wishlist group menu
       handleDropWishlistGroup(event, wishlistGroupIndex){
        let that = this
    
        // const wishlistID = event.dataTransfer.getData('wishlistID')

        // multiple wishlists........

        // this.wishlists.map(w=>{
        //   if(w.id == wishlistID) {
        //     // subtract numItem from original group and add to the new group
        //     that.wishlistGroups.map(wishlistGroup=>{
        //       if(wishlistGroup.id == w.groupID)
        //         wishlistGroup.numItems --
        //     })
        //     w.groupID = that.wishlistGroups[wishlistGroupIndex].id
        //     that.wishlistGroups[wishlistGroupIndex].numItems ++
        //     w.selected = false
        //   } 
        // })
        console.log("handleDropWishlistGroup", wishlistGroupIndex)
        if(this.wishlists.filter(w=>w.selected).length == 0) {
          this.displayGlobalMessage("Select wishlist(s) first", 1500)
          return false;
        }
        let wishlistMovedIDs = []
         this.wishlists.map(w=>{
          if(w.selected) {
            // subtract numItem from original group and add to the new group
            that.wishlistGroups.map(wishlistGroup=>{
              if(wishlistGroup.id == w.groupID) 
                wishlistGroup.numItems --
            })
            w.groupID = that.wishlistGroups[wishlistGroupIndex].id
            that.wishlistGroups[wishlistGroupIndex].numItems ++
            wishlistMovedIDs.push(w.id)
            w.selected = false
          } 
        })






        // update server
        this.axios.post(process.env.VUE_APP_API_BASE_URL+'/updateWishlistGroupID',{
          wishlistMovedIDs,
          groupID: that.wishlistGroups[wishlistGroupIndex].id
        }).then((response) => {
          console.log(response)
        })

        

       },
       handleStartDragWishlistGroup(event, wishlist){
        // console.log("handleDropWishlistGroup")
        // console.log(event)
        
        event.dataTransfer.dropEffect = 'move'
        event.dataTransfer.effectAllowed = 'move'
        event.dataTransfer.setData('wishlistID', wishlist.id)
       },
       // selecting wishlist from the wishlist group menu
       selectWishlistGroup(group) {
        // console.log(group, group.id)
        // get back to wishlist view
        this.selectedWishListID = -1
        this.wishlistGroups.map(g=>g.selected = false)
        this.selectedWishlistGroupID = group.id
        group.selected = true 
        this.$forceUpdate()
        console.log(this.selectedWishlistGroupID)
      },
      addWishlistGroup(){
        if(this.newWishlistGroupName.trim() != '') {
          this.axios.post(process.env.VUE_APP_API_BASE_URL+'/addWishlistGroup',{
            email: this.user.email,
            wishlistGroupName: this.newWishlistGroupName.trim()
          }).then((response) => {
            // console.log(response)
            this.wishlistGroups.splice(1, 0, {
              id: response.data.groupID,
              selected: false,
              numItems: 0,
              name: this.newWishlistGroupName.trim()
            })
            this.newWishlistGroupName = ''
          })
        }
      },
      deleteWishlistGroup(wishlistGroupIndex){
        let that = this
        this.axios.post(process.env.VUE_APP_API_BASE_URL+'/deleteWishlistGroup',{
          email: this.user.email,
          wishlistGroupID: this.wishlistGroups[wishlistGroupIndex].id
        }).then((response) => {
          console.log(response)
          if(response.data.success) {
            if(that.wishlistGroups[wishlistGroupIndex].selected) {
              that.selectWishlistGroup(that.wishlistGroups[0])
            }
            this.wishlistGroups.splice(wishlistGroupIndex, 1)
          }
        })
      },
      showFilteredProductResults(){
        let that = this
        that.productSearchResults.map(p=>p.show=true)
        if(this.vendors.findIndex(v=>v.selected) != -1) {
          that.productSearchResults.map(p=>{
            that.vendors.findIndex(v=>v.Vend_Num == p.Vend_Num && v.selected) == -1 ? p.show = false : ''
          })
        }
        if(this.categories.findIndex(c=>c.selected) != -1) {
          that.productSearchResults.map(p=>{
            let index = that.categories.findIndex(c=>c.category_ID == p.category_ID && c.selected) 
            if(index == -1)
              p.show=false
          })
        }
        // console.log(this.productSearchResults.filter(p=>p.show).length)
      },
      fillInCustomerPriceColumn(){
        // let that = this
        this.axios.post(process.env.VUE_APP_API_BASE_URL+'/getCustomerPrices',{
          selectedCustomerID: this.selectedCustomerID,
          // wishlistGroupID: this.wishlistGroups[wishlistGroupIndex].id
          selectedWishListID: this.selectedWishListID
        }).then((response) => {
          console.log(response)
          if(response.data.success) {
            console.log(response.data.success)
            response.data.result.forEach((item, index)=>{
              this.selectedWishListItems[index].lastSoldPrice = item.lastSoldPrice.toFixed(2)
            })
          }
        })
      },
      saveUserPreferences(){
        let that = this
        clearInterval(this.timerId)
        this.timerId = setTimeout(function() {
          console.log(that)
          console.log('saving user preferences')
          that.axios.post(process.env.VUE_APP_API_BASE_URL+'/saveUserPreferences',{
            userPreferences: that.userPreferences,
            user: that.user,
          }).then((response) => {
            console.log(response)
            if(response.data.success) {
              console.log(response.data.success)
            }
          })
        }, 1000) 
      },
      getUserPreferences() {
        let that = this
        this.axios.post(process.env.VUE_APP_API_BASE_URL+'/getUserPreferences',{
          user: this.user
        }).then((response) => {
          console.log(response)
          if(response.data.success) {
            console.log(response.data.result)
            if(response.data.result.length > 0) {
              that.userPreferences = JSON.parse(response.data.result[0].config)
            } else {
              this.userPreferences = {}
              this.userPreferences.wishlistColumns = {
                productID: true,
                Vend_Num: true,
                category_ID: true,
                group_ID: true,
                description: true,
                unit_depth: true,
                unit_width: true,
                unit_height: true,
                Size: true,
                inner_size: true,
                case_pack: true,
                case_Vol: true,
                unit: true,
                Base_Cost: true,
                poQty: true,
                ctns: true,
                cbm: true,
                amt: true,
                inStockQty: true,
                openSoQty: true,
                availableQty: true,
                woQty: true,
                availableQty1: true,
                poQty1: true,
                More_Notes_13: true,
                More_Notes_14: true,
                More_Notes_16: true,
                More_Notes_17: true,
                lastSoldPrice: true
                
              }
            }
          }
        })
      }
    },
    computed: {
      categoriesWithProductCount(){
        return this.categories.filter(c=>c.productCount > 0)
      },  
      vendorsWithProductCount(){
        return this.vendors.filter(v=>v.productCount > 0)
      },  
      wishlistsFilteredByGroupID() {
        let that = this
        return this.wishlists.filter(w=>w.groupID == that.selectedWishlistGroupID)
      },
      modifiedWishList() {
        return this.selectedWishListItems.findIndex(item=>{
          return item.new != undefined && item.new
        }) != -1 || this.modifiedWishListFlag
      },
      selectedWishListName() {
        if(this.selectedWishListID != -1) {
          let index = this.wishlists.findIndex(wishlist=>this.selectedWishListID == wishlist.id)
          return index != -1 ? this.wishlists[index].name : ""
        }
        return ""
      },
    },
    mounted() {
      console.log('mounted')
      if(process.env.NODE_ENV == 'development') {
        this.user = {
          email: "rogert@turtleking.com",
            id: 10,
            name: "Roger",
            type: "admin",
            vendor_id: ""
        } 
      }
      else 
        this.user = cookies.get("tkcID")
      
      // console.log("user")
      // console.log(this.user)





      this.getAllWishlist()
      this.getCriteria()
      // this.$router.push('/about')
      this.searchProductDebounced()
      this.getUserPreferences()
      // console.log(document.documentElement.clientHeight, document.documentElement.clientWidth)
      this.contentHeight = document.documentElement.clientHeight - 60
      
      // let that = this, user = cookies.get("tkcID")
      
      window.addEventListener('resize', () => {
          this.contentHeight = document.documentElement.clientHeight - 40
          if(this.windowWidth != document.documentElement.clientWidth) {
            this.setPaneWidth(true)
          }
      });
    }
  }

</script>
  































<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .wishlist_menu {
    .content {
      background-color:white;
      border-radius: 10px;
      border: 2px solid #b3b3b3;
      margin:0 auto;
      max-width:98%;
      margin-top:15px;
      // padding-bottom: 20px;
      height:900px;
      // margin-bottom:40px;
      .globalMessage {
        display: block;
        margin: 10% auto;
        font-weight: bold;
        position: absolute;
        /* left: calc(50% - 10px); */
        height: 100%;
        width: 100%;
        z-index: 3;
        background-color: rgba(255, 255, 255, 0.3);
        top: 0;
        margin: 0 auto;
        span{
          border: 3px solid grey;
          display: inline-block;
          margin: 20% auto;
          padding:10px;
          background-color:white;
          text-transform:uppercase;
        }
      }
      .topPane > i{
        color:#d86c8e;
      }
      .topPane{
        display:block;
        width:100%;
        text-align: left;
        // height:40px;
        a{
          font-size:15px;
          display:inline-block;
          padding:5px;
          padding-left:10px;
        }
        border-bottom:3px solid #ccc;
          button.left{
            border-top-left-radius: 9px;
            border-bottom-left-radius: 9px;
          }
          button.right{
            border-top-right-radius: 9px;
            border-bottom-right-radius: 9px;
          }
        }
      
      .leftPane,
      .rightPane{
        display:inline-block;
        vertical-align:top;
        position:relative;
        width:calc(50% - 8px);
        // transition: width 0.4s ease-in-out;
        height: calc(100% - 30px);
        overflow-y: hidden;
        border:none;

      }
      .middlePane{
        width:10px;
        display:inline-block;
        height:100%;
        // border:3px solid #ccc;
        vertical-align:middle;
        border-left:3px solid #ccc;
        border-right:3px solid #ccc;
        max-height: calc(100% - 32px);
      }
      .middlePane:hover{
        cursor:col-resize;
        border-left:3px solid grey;
        border-right:3px solid grey;
        background-color:grey;
      }
      .leftPane{
        // border-bottom:2px solid #ccc;
        position:relative;
        .searchField:hover {
          // border: 1px solid #b3b3b3;
        }
        .searchField{
          border-radius: 0px;
          width: 60%;
          height: auto;
          box-sizing: border-box;
          margin: 0 auto;
          margin: 11px auto;
          // padding:10px;
          position:relative;
          // background-color:#ebebeb;
          border-radius: 8px;
          
          input[type=text]{
            border: 2px solid #ebebeb;
            // border:none;
            display: inline-block;
            vertical-align: middle;
            text-transform:uppercase;
            outline: 0;
            margin: 2px;
            box-sizing: border-box;
            height: 100%;
            font-size: 20px;
            padding: 0 20px;
            background: none;
            width: 100%;
            text-align:center;
            color:black;
          }
          input[type=text]:hover,
          input[type=text]:focus{
            border: 2px solid #b3b3b3;
              // border: none !important;
          }
          img{
            display:inline-block;
            vertical-align: middle;
            width: 30px;
            position: absolute;
            right: -35px;
            top: 9px;
          }
        }
        .filters.open{
          height:200px;
          max-height:90%;
          .filterContainer{
            display:block;
          }
        }
        .filters{
          
          position:absolute;
          top:40px;
          width:100%;
          z-index:2;
          height:0px;
          box-sizing: border-box;
          box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.2);
          background-color:#ebebeb;
          transition: height 0.1s ease-in-out;
          .openClosetTab{
            border: 1px solid #ccc;
            display: inline-block;
            border-bottom-left-radius: 3px;
            border-top: none;
            border-bottom-right-radius: 2px;
            padding: 3px 10px;
            background-color: #ebebeb;
            cursor: pointer;
          }
          .filterContainer{
            display:none;
            height:100%;
            .filterGroup{
              position:relative;
              padding: 5px 5px 25px 5px;
              text-align: left;;
              box-sizing: border-box;
              display:inline-block;
              width:50%;
              vertical-align: top;
              height: 100%;
              overflow-y: scroll;
              button{
                // position:absolute;
                // left:0;
                // bottom:0
                // position: relative;
                left: 5px;
                bottom: 5px;
                display: block;
                margin-top: 10px;
                text-decoration: underline;
                background: none;
                color: black;


              }
              .filter{
                display:inline-block;
                text-align: left;
                width:49%;
                cursor: pointer;
                padding: 5px 0;
                box-sizing: border-box;
              }
              .filter:hover {
                background-color:#ccc;
              }
            }
          }
          .filterGroup:first-child{
            border-right:1px solid #ccc;
          }
        }
        .results{
          overflow:scroll;
          // border-top:2px solid #ccc;
          position:relative;
          margin-top:37px;
          height:calc(100% - 83px);
          table {
            tbody {
              tr {
                td {
                  text-align:left;
                }
                td:first-child,
                th:first-child{
                  text-align: center;
                  position: sticky;
                  left: 0;
                  background:rgba(255, 255,255, 1);
                  i.fa-magnifying-glass-plus{
                    position: absolute;
                    top: 3px;
                    right: 0;
                    opacity: 0.8;
                    color: #d86c8e;
                    font-size: 20px;
                  }
                  i.fa-magnifying-glass-plus:hover{
                    opacity:1;
                  }
                  .zoomImage{
                    position: absolute;
                    width: 401px;
                    top: 0;
                    left: 100%;
                    height: 400px;
                    z-index: 3;
                    img{
                      width:auto;
                      max-width:100%;
                    }
                  }
                }

              }
              tr:hover{
                background-color:#ebebeb;
                cursor:pointer;
                
              }
            }
          }
          .nosearchresult{
            display:block;
            font-weight:bold;
            width:300px;
            text-transform:uppercase;
            padding:10px 0;
            margin: 50px auto;
            border-radius:5px;
            border:1px solid #ccc;
            // background-color:#ebebeb;
          }
        }
      }
      .rightPane {
        position:relative;
        overflow-x: hidden;
        .wishlistGroups.hide {
          right:-300px;
        }
        .wishlistGroups {
          box-sizing: border-box;
          position: absolute;
          text-align: left;
          right: 0;
          top: 0;
          width: 300px;
          box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.2);
          height: 100%;
          background: rgba(255, 255, 255, 1);
          border-left: 3px solid #ebebeb;
          z-index: 2;
          transition: right 0.5s ease-in-out; 
          span{
            display:block;
            width:calc(100% - 13px);
            position:relative;
          }
          i.fa-trash:hover {
            opacity:1;
          }
          i.fa-trash {
            color:red !important;
            position:absolute;
            right:16px;
            top:10px;
            opacity:0.5;
          }
          span.label{
            background-color: grey;
            color:white;
            padding:10px;
          }
          span.newFolder {
            padding:5px;
            display:block;
            input{
              height: 20px;
              border: 2px solid #b3b3b3;
              margin-right: 0px;
              display: inline-block;
              vertical-align: middle;
            }
          }
          .openCloseTab{
            cursor: pointer;
            position: absolute;
            left: -27px;
            font-size: 29px;
            background: white;
            border-radius: 5px;
            border: 3px solid #ebebeb;
            padding: 10px 5px;
            
          }
          ul{
            padding: 10px;
            list-style:none;
            li {
              padding:5px;
              font-weight:bold;
              text-transform: uppercase;
              // border-bottom:3px solid #ebebeb;
              box-sizing: border-box;
              cursor:pointer;
              border-radius:5px;
              border:2px solid #ffffff;
              position: relative;
            }
            li:hover {
              border:2px solid #ebebeb;
            }
            li.selected {
              color:#d86c8e;
            }
            li.indented {
              padding-left:20px;
            }
            
          }
        }
        // border-bottom:2px solid #ccc;
        .wishlists{
          // display:inline-block;
          // vertical-align: top;
          // width:60%;


          height:calc(100% - 50px);
          text-align:left;
          overflow-y: scroll;
          .wishlistsTbl {
            td {
              input[type=text] {
                // border:none;
                border:3px solid white;
                text-transform: uppercase;
              }
              button.saveBtn {
                text-decoration: none;
                color: #d86c8e;
                font-weight: bold;
              }
            }
          }
        }
        .wishlistItems {
          //  display:inline-block;
          // vertical-align: top;
          // width:60%;

          height:100%;
          .wishlistItemsTblDiv{
            height: calc(100% - 82px);
            overflow-y: scroll;
            width: 100%;
            .wishlistItemsTbl{
              tr {
                td {
                  position:relative;
                  i.fa-magnifying-glass-plus {
                    color: #d86c8e;
                    position:absolute;
                    right:5px;
                    top:5px;
                  }
                }
              }
            }


          }
          .modifiedWishListCtl {
            display: inline-block;
            // float: right;
            position: fixed;
            top: 17px;
            right: 59px;
            div {
              
              button.saved {
                background-color:white;
                color: rgb(136 148 146 / 70%);
                // border: 3px solid rgb(136 148 146 / 70%);
                font-weight:bold;
              }
              span.astrisk{
                vertical-align: middle;
                display: inline-block;
                line-height: 0px;
                font-size: 24px;
                line-height: 1.2em;
                color: #d86c8e;
                padding-right: 6px;
              }
              button.unsaved {
                // font-weight:bold;
                color:white;
                text-decoration: none;;
                background-color:#d86c8e;
              }
            }

          }
          // table.wishlistItemsTbl{
            // .wishlistItems {
            //   .row{
            //     height:30px;
            //     display:block;
            //     span{
            //       display:inline-block;
                  
            //     }
            //   }
              
            // }
          // }
          .bulk_addToWishlist_Area{
            margin-top:50px;
            text-align:left;
            padding-left:50px;
            span {
              display:block;
            }
            textarea{
              width: 500px;
              height: 300px;
              text-transform: uppercase;
              max-width: 100%;
            }
            button {
              display:block;
              background: rgba(136, 148, 146, 0.7);
              color: white;
              text-decoration: none;
            }
          }
        }
      }
    }
    .footer{
      display:block;
      height:100px;
      width:100%;
    }
  }
  











  table {
    width: 100%;
    border-collapse: collapse; /* Optional: for cleaner borders */
    th {
      text-transform:uppercase;
      font-weight:bold;
      position: sticky; /* Make the header sticky */
      top: 0; /* Stick to the top of its scroll container */
      color: #f4f4f4; /* Important: Provide a background to cover scrolling content */
      background-color:grey;
      z-index: 1; /* Ensure the header stays above the table body */
      padding: 10px; /* Optional: for spacing */
      border-right:1px solid white;
    }
    tr:hover {
      background-color:#ebebeb;
      cursor:pointer;
    }
    tr.selected:hover,
    tr.selected {
      background-color:#ccc !important;
    }
    td {
      border:1px solid #ebebeb;
      padding: 10px;
      i{
        // margin-left:10px;
        margin:0;
        margin-bottom:5px;
        font-size:20px;
        opacity:0.6;
      }
      i.fa-solid.fa-trash-can {
        color:red;
      }
      i.fa-solid.fa-copy {
        color:forestgreen;
      }
      i:hover {
        opacity:1;
      }
      img.productImage {
        width:100px;
      }

    }
  }






  .login{
    display:block;
    .content{
      .field{
        label{
          width: 81px;
          display: inline-block;
          margin: 0 auto;
          text-align: right;
          font-weight: 300;
        }
      }
      button{
        margin: 12px auto;
      }
    }
  }




  .controlPane {
    position:relative;
    .newishlistBtn{
      margin:5px 0;
    }
    text-align: center;
    // padding-bottom:10px;
    span.recordsFound {
      padding-left:10px;
      float:left;
    }
    span.productSearchResultsNumItems{
      float:right;
      padding-right:20px;
      padding-bottom:10px;
      select {
        padding-left:10px;
        width:auto;
      }
      padding-right:20px;
    }
    .downloadExcel{
      display: inline-block;
      border: 1px solid #ebebeb;
      padding: 4px 10px;
      margin-top: 10px;
      span{
        display:inline-block;
        padding:5px 10px 0 0;
      }
      select{
        padding: 3px 25px;
        vertical-align: middle;
      }
      button{
        margin-left:10px;
      }
    }
    .wishlistNameLabel{
      display:block;
      text-align:center;
      text-transform:uppercase;
      padding:5px 10px;
      box-sizing:border-box;
    }
    .backBtnArea{
      // display:inline-block;
      padding:5px 10px;
      position:absolute;
      left:0;
      top:20px;
      cursor: pointer;
    }
    .backBtnArea:hover {
      text-decoration: underline;
    }
    .wishlistNameLabel{
      display:inline-block;
      font-weight:bold;
      padding:5px 10px;
    }
    .customizeColumns{
      display:inline-block;
      position:absolute;
      left:10px;
      top:53px;
      z-index: 3;
      overflow:visible;
      text-align: left;
      span{
        text-decoration: underline;
        cursor: pointer;
      }
      div{
        background: white;
        box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.2);
        // position:
        width:auto;
        height:600px;
        overflow-y:scroll;
        ul{
          list-style: none;
          margin-left: 0;
          padding:0;
          li {
            padding: 5px 10px;
            cursor: pointer;
            font-weight:bold;
            // border-bottom:1px solid #ccc;
            input{
              margin-right: 8px;
              display: inline-block;
            }
          }
          li:hover {
            background-color:#ebebeb;
          }
        }
      }
    }
  }


  button {

    // background:none;
    // color: rgba(0, 0, 0, 0.5);
    // text-decoration: underline;
  }
  button:hover {
    //  border: 2px solid rgba(0,0,0, 0.5);
    //   background-color: rgba(0,0,0, 0.5);
    //   color: white;
    // color: rgba(0, 0, 0, 1);
  }
  button.downloadBtn{
    background:rgba(136, 148, 146, 0.7);
    color: white;
    text-decoration: none;
  }
  button.downloadBtn:hover{

  }
  .triangle-up {
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 5px solid white;
position: relative;
  left: 15px;
  display: inline-block;
  vertical-align: middle;
  }

  .triangle-down {
    width: 0;
    height: 0;
    border-left:5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid white; /* Adjust size and color as needed */
    // top: 27px;
    //   position: absolute;
      left: 15px;
    display:inline-block;
    position: relative;
    vertical-align: middle;;
  }

.image-zoom-image{
  position:relative;
  .productImage{
    max-width: 100%;
    width: auto;
    display: block;
    margin: 30px auto;
  }
  .upload{
    display: inline-block;
    .uploadBtn{
      width: 250px;
      height:30px;
      cursor: pointer;
      position:relative;
      input{
        left: 0;
        cursor: pointer;
        position: absolute;
        opacity: 0;
        z-index: 2;
        width: 100%;
        height: 100%;
      }
      button{
        height: 100%;
        position: absolute;
        z-index: 1;
        left: 0;
        width: 100%;
      }
    }
    .uploadBtn:hover button{
      background: rgba(136, 148, 146, 1);

    }
  }
}

</style>
  